import { type PropsWithChildren, createContext } from "react"
import type { StepUpTokenService } from "../../hooks"
import type { SsoService } from "../../sso"
export interface AppContextShape {
  sso: SsoService
  stepUpToken: StepUpTokenService
}

/**
 * ⚠️ Beware, every change creates an app rerender
 */
export const AppContext = createContext<AppContextShape>(undefined!)

export const AppContextProvider = ({
  sso,
  stepUpToken,
  children,
}: PropsWithChildren<AppContextShape>) => {
  return (
    <AppContext.Provider
      value={{
        sso,
        stepUpToken,
      }}
    >
      {children}
    </AppContext.Provider>
  )
}
